import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';
import AdminActions from '../../actions/AdminActions';
import UserForm from '../../components/UserForm.react';


export default class ManageUser extends Component {
  constructor(props) {
    super(props);
    this.deleteUser = this.deleteUser.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  backToAdminOptions() {
    const { router } = this.context;
    router.push('/admin/options');
  }

  getInitialTableauUser() {
    if (this.props.membership.tableauUser) {
      return this.props.membership.tableauUser;
    } else {
      return null;
    }
  }

  deleteUser() {
    /* eslint-disable */
    if (confirm('Are you sure you want to delete this user?  Press ok to continue.')) {
    /* eslint-enable */
      AdminActions.requestDeleteMembership(this.props.user.id, this.props.organization.id);
      this.backToAdminOptions();
    }
  }

  handleSubmit(newValue) {
    AdminActions.updateMembership(
      this.props.user.id,
      this.props.organization.id,
      newValue.role,
      newValue.tableauUser,
      (this.getInitialTableauUser() && !(newValue.tableauUser)));
    this.backToAdminOptions();
  }

  render() {
    return (
      <div>
        <h3>Update User</h3>
        <UserForm initialEmail={this.props.user.email}
          initialRole={this.props.membership.role}
          availableRoles={this.props.availableRoles}
          availableTableauUsers={this.props.availableTableauUsers}
          initialTableauUser={this.getInitialTableauUser()}
          defaultTableauUser={this.props.organization.defaultTableauUser}
          emailReadOnly
          onSubmit={this.handleSubmit}
        />
        <Button
          bsStyle='danger'
          bsSize='large'
          onClick={this.deleteUser}
          style={{ marginTop: 20 }}
        >
          Delete
        </Button>
      </div>
    );
  }
}

ManageUser.contextTypes = {
  router: PropTypes.object,
};

ManageUser.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
  }),
  organization: PropTypes.shape({
    id: PropTypes.number,
    defaultTableauUser: PropTypes.string,
  }),
  membership: PropTypes.shape({
    role: PropTypes.number,
    tableauUser: PropTypes.string,
  }),
  availableRoles: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      id: PropTypes.number,
      roleClass: PropTypes.string,
    })
  ).isRequired,
  availableTableauUsers: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      tableauUser: PropTypes.string,
    })
  ).isRequired,
  role: PropTypes.number,
  tableauUser: PropTypes.string,
};
